import { Button } from 'lucid-components-react';
import React, { useState } from 'react';

import './paginator.scss';

interface Props {
  items: JSX.Element[];
  pageSize: number;
  nextClass?: string;
  nextJsx: JSX.Element;
  alwaysRender?: boolean;
  render: (items: JSX.Element[]) => JSX.Element;
}

const Paginator = ({
  items,
  pageSize,
  nextJsx,
  nextClass,
  render,
  alwaysRender = false
}: Props) => {
  const [activePage, setActivePage] = useState(1);
  let pagedItems = items.slice(0, activePage * pageSize);
  const totalItemCount = items.length;
  const block = 'paginator';
  const hasMore = totalItemCount > pageSize * activePage;

  if (alwaysRender) {
    pagedItems = items.map((item, i) => {
      if (i >= activePage * pageSize) {
        return React.cloneElement(item, {
          key: i,
          className: `${block}__hidden`,
          'data-grid-class': `${block}__hidden`
        });
      }

      return item;
    });
  }

  return (
    <div className={`${block}`}>
      {render(pagedItems)}
      {hasMore && (
        <Button
          asLink
          className={`${block}__next ${nextClass || ''}`}
          onClick={() => setActivePage(activePage + 1)}
        >
          {nextJsx}
        </Button>
      )}
    </div>
  );
};

export default Paginator;
